<template>
	<div>
		<div class="block">
			<div class="block-content pb-2">
				<div class="d-flex">
					<div
						style="min-width: 100px; max-width: 100%;"
						class="flex-grow-1 flex-shrink-0 h4"
					>
						{{ venue.name }}
					</div>
					<div
						class="flex-grow-0 flex-shrink-0 text-right"
					>
						<a
								:href="getMpLink()"
								target="_blank"
								class="text--darken-4 light-blue--text font-weight-medium"
						>
							<span class="text-decoration-underline">Merchant Portal</span> <i class="fa fa-external-link-alt"></i>
						</a>
					</div>
				</div>
				<v-divider class="mt-0 mb-7"></v-divider>
				<div id="merchants-accordion" class="accordion">
					<div
						class="d-flex justify-content-between p-2 mb-1"
						data-toggle="collapse"
						:data-target="'#collapse-0'"
						aria-expanded="false"
						:aria-controls="'collapse-0'"
						:class="[!selectedUserId && selectedUser == 'admin' ? 'bg-body-light' : 'bg-body-white']"
						@click="
							$emit('get-all-logs', true)
							selectedUserId = 0
							selectedUser = 'admin'
						"
					>
						<div class="form-check form-check-inline">
							<label class="form-check-label" for="allLogs"><a id="allLogs" href="" @click.prevent="">All Logs</a></label>
						</div>
						<div></div>
					</div>
					<div :id="'collapse-0'" class="collapse" data-parent="#merchants-accordion" v-if="showLogs">
						<div class="" id="logs-0" v-if="allLogs.messagePaginator && allLogs.messagePaginator.data">
							<div class="tab-content">
								<ul class="timeline timeline-alt">
									<li class="timeline-event mb-1" v-for="message in allLogs.messagePaginator.data">
										<div class="timeline-event-icon bg-danger" v-if="message.type == 'email'">
											<i class="fa fa-envelope"></i>
										</div>
										<div class="timeline-event-icon bg-primary" v-if="message.type == 'text'">
											<i class="far fa-comment"></i>
										</div>
										<div class="timeline-event-icon bg-secondary" v-if="message.type == 'feed'">
											<i class="fab fa-stack-exchange"></i>
										</div>
										<div
											class="timeline-event-icon"
											:class="message.subject == 'Outbound Call' ? 'bg-info' : 'bg-warning'"
											v-if="message.type == 'phone' || message.type == 'call'"
										>
											<i class="fa fa-phone-alt"></i>
										</div>
										<div class="timeline-event-block block js-appear-enabled animated fadeIn" data-toggle="appear">
											<div class="block-header block-header-default">
												<h3 class="block-title">
													{{ message.title }}
												</h3>
												<div class="block-options">
													<div class="timeline-event-time block-options-item font-size-sm font-w600">
														<span :title="message.date">{{ Bandwango.dateToLocal(message.date) }}</span>
													</div>
												</div>
											</div>
											<div class="block-content">
												<div class="media font-size-sm push">
													<div class="media-body">
														<p class="mb-0">
															{{ Bandwango.truncateFilter(message.content, 300) }}
														</p>
													</div>
												</div>
											</div>
										</div>
									</li>
									<li class="timeline-event pl-5" v-if="allLogs.messagePaginator.to < allLogs.messagePaginator.total">
										<div class="btn btn-sm w-100 border" @click="getVenueLogs(false)">
											Load More
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div v-if="merchants && merchants.length" v-for="merchant in orderedMerchants" :key="merchant.id">
						<div
							class="d-flex justify-content-between p-2 mb-1"
							data-toggle="collapse"
							:data-target="'#collapse-' + merchant.id"
							aria-expanded="false"
							:aria-controls="'collapse-' + merchant.id"
							@click="
								$emit('selected-merchant', merchant)
								$emit('get-merchant-logs', merchant)
								selectedUserId = merchant.id
								selectedUser = !selectedUser
							"
							:class="[merchant.id == selectedUserId ? 'bg-body-light' : 'bg-body-white']"
						>
							<div class="form-check form-check-inline">
								<label class="form-check-label" :for="'primaryContact_' + merchant.id"
									><a href="" @click.prevent="" :style="[merchant.id == selectedUserId ? { color: '#82BA0C' } : { color: '#003E52' }]">{{ displayName(merchant) }}</a></label
								>
							</div>
							<div class="form-check--call-buttons">
								<div v-if="merchant.onboardLinks && merchant.onboardLinks.campaigns.length" class="btn-group">
									<button type="button" class="btn btn-warning dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i class="fa fa-external-link-alt"></i>
									</button>
									<ul class="dropdown-menu">
										<li v-for="camp in merchant.onboardLinks.campaigns">
											<a class="dropdown-item removeProduct" @click="copyToClip(camp.link, $event)" style="cursor: pointer;">{{ camp.name }}</a>
										</li>
									</ul>
								</div>
								<span v-if="merchant.phone">
									<div v-if="merchant.secondary_phone" class="btn-group">
										<button type="button" class="btn btn-success dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											<i class="fa  fa-phone-alt"></i>
										</button>
										<ul class="dropdown-menu">
											<li>
												<a class="dropdown-item removeProduct" @click.prevent="callMerchant(merchant, $event)" style="cursor: pointer;">{{ merchant.phone | phone }}</a>
											</li>
											<li>
												<a class="dropdown-item removeProduct" @click.prevent="callMerchant(merchant, $event, 'secondary_phone')" style="cursor: pointer;">{{
													merchant.secondary_phone | phone
												}}</a>
											</li>
										</ul>
									</div>
									<button class="btn btn-success btn-sm" @click.prevent="callMerchant(merchant, $event)" v-else>
										<i class="fa fa-phone-alt"></i>
									</button>
								</span>
								<button v-if="merchant.email" class="btn btn-danger btn-sm" @click.prevent="openMessage(merchant, $event)">
									<i class="fa fa-envelope"></i>
								</button>
								<button
									class="btn btn-info btn-sm"
									@click.prevent="
										editContact(merchant, $event)
										newUser = false
									"
								>
									<i class="fa fa-pencil-alt"></i>
								</button>
							</div>
						</div>
						<div :id="'collapse-' + merchant.id" class="collapse" data-parent="#merchants-accordion">
							<ul class="nav nav-tabs nav-tabs-block">
								<li class="nav-item" v-if="merchant.messagePaginator && merchant.messagePaginator.data">
									<a class="nav-link active" data-toggle="tab" :href="'#contact-logs-' + merchant.id" v-if="showLogs">Logs</a>
								</li>
								<li class="nav-item" v-if="merchant.venues && merchant.venues.length > 1">
									<a class="nav-link" data-toggle="tab" href="#venues">Other Venues</a>
								</li>
							</ul>
							<div class="pl-3 tab-content">
								<div class="tab-pane active" :id="'contact-logs-' + merchant.id" v-if="merchant.messagePaginator && merchant.messagePaginator.data && showLogs">
									<div class="tab-content">
										<ul class="timeline timeline-alt">
											<li class="timeline-event mb-1" v-for="message in merchant.messagePaginator.data">
												<div class="timeline-event-icon bg-danger" v-if="message.type == 'email'">
													<i class="fa fa-envelope"></i>
												</div>
												<div class="timeline-event-icon bg-primary" v-if="message.type == 'text'">
													<i class="far fa-comment"></i>
												</div>
												<div class="timeline-event-icon bg-secondary" v-if="message.type == 'feed'">
													<i class="fab fa-stack-exchange"></i>
												</div>
												<div
													class="timeline-event-icon"
													:class="message.subject == 'Outbound Call' ? 'bg-info' : 'bg-warning'"
													v-if="message.type == 'phone' || message.type == 'call'"
												>
													<i class="fa fa-phone-alt"></i>
												</div>
												<div class="timeline-event-block block js-appear-enabled animated fadeIn" data-toggle="appear">
													<div class="block-header block-header-default">
														<h3 class="block-title">
															{{ message.title }}
														</h3>
														<div class="block-options">
															<div class="timeline-event-time block-options-item font-size-sm font-w600">
																<span :title="message.date">{{ Bandwango.dateToLocal(message.date) }}</span>
															</div>
														</div>
													</div>
													<div class="block-content">
														<div class="media font-size-sm push">
															<div class="media-body message-container">
																<p class="mb-0" v-if="!message.readMore">
																	{{ Bandwango.truncateFilter(message.content, 200) }}
																	<span v-if="message.content && message.content.length > 200" class="ml-1 btn btn-light btn-sm" @click="expand(message)"
																		>Read More</span
																	>
																</p>
																<p class="mb-0" v-else v-html="message.content"></p>
															</div>
															<div class="full-width m-1 p-1 border" v-if="message.notes && message.notes.length">
																<div class="full-width m-1" v-for="note in message.notes" :key="note.id">
																	<i class="fa fa-file mr-1"></i
																	><small
																		>{{ note.userName }}
																		-
																		<a
																			class="noteDate"
																			href="#"
																			onclick="return false;"
																			data-toggle="tooltip"
																			:title="Bandwango.dateToLocal(note.created_at, false, 'MMMM Do YYYY, h:mm:ss a')"
																			>{{ Bandwango.dateToLocal(note.created_at) }}</a
																		></small
																	><br />
																	<span class="font-size-sm ml-3" v-html="note.message"></span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li class="timeline-event pl-5" v-if="merchant.messagePaginator.to < merchant.messagePaginator.total">
												<div class="btn btn-sm w-100 border" @click="getMerchantLogs(merchant)">
													Load More
												</div>
											</li>
										</ul>
									</div>
								</div>
								<div class="tab-pane" id="venues" v-if="merchant.venues && merchant.venues.length > 1">
									<div class="tab-content">
										<table class="table table-striped">
											<tr v-for="v in merchant.venues" v-if="v.id != venue.id">
												<td>
													<a :href="(superAdmin ? '/superAdmin' : '') + '/callCenters/' + v.id">{{ v.name }}</a>
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="block-header block-header-default d-flex justify-content-between bg-white">
				<div>
					<button class="btn btn-primary btn-sm mt-2 mb-2" @click.prevent="newContact(true)"><i class="fa fa-plus mr-1"></i>New Contact</button>
					<button v-if="systemUser && systemUser.id" class="btn btn-danger btn-sm ml-1" data-toggle="modal" data-target="#sendMessageSystem">
						<i class="fa fa-envelope-open-text mr-1"></i>Email Managers
					</button>
				</div>
			</div>
		</div>

		<div class="modal fade" id="add-edit-contact" tabindex="-1" role="dialog" aria-labelledby="add-edit-contact">
			<div class="modal-dialog" role="document">
				<form @submit.prevent="onSubmit">
					<div class="modal-content">
						<div class="modal-header bg-body-light">
							<h4 class="modal-title" id="inviteModalLabel">
								{{ contact.id ? 'Edit ' + contact.name : 'New Contact' + (venue ? ' for ' + venue.name : '') }}
							</h4>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="form-group row">
								<label for="firstname" class="control-label col-lg-3">First Name:</label>

								<div class="controls col-lg-6">
									<input type="text" id="firstname" name="name" class="form-control" v-model="contact.first_name" />
									<span class="invalid-feedback" style="display: block;" v-if="errors.first_name">{{ errors.first_name }}</span>
								</div>
							</div>

							<div class="form-group row">
								<label for="lastname" class="control-label col-lg-3">Last name:</label>

								<div class="controls col-lg-6">
									<input type="text" id="lastname" name="name" class="form-control" v-model="contact.last_name" />
									<span class="invalid-feedback" style="display: block;" v-if="errors.last_name">{{ errors.last_name }}</span>
								</div>
							</div>

							<div class="form-group row">
								<label for="external_id" class="col-lg-3 control-label">Email:</label>

								<div class="controls col-lg-6">
									<input id="external_id" name="external_id" class="form-control" type="email" v-model="contact.email" autocomplete="new-password" />
									<span class="invalid-feedback" style="display: block;" v-if="errors.email">{{ errors.email }}</span>
								</div>
							</div>

							<div id="roleDiv" class="form-group row" v-if="roles && roles.length">
							<label for="role_id" class="col-lg-3 control-label">Role:</label>
							<div class="controls col-lg-6">
								<select id="role_id" name="role_id" class="form-control" data-placeholder="Select a role..." v-model="contact.role_id" :is-required="true">
								<option v-for="(venueRole, vrIdx) in roles" :value="venueRole.id" :key="vrIdx">{{venueRole.name}}</option>
								</select>
								<span class="help-block"></span>
							</div>
							</div>

							<div class="form-group row">
								<label class="control-label col-lg-3">Phone:</label>

								<div class="controls col-lg-6">
									<bw-phone v-model="contact.phone" :allow-extensions="true" :extension="contact.phone_ext" @extension="contact.phone_ext = $event" ></bw-phone>
								</div>
							</div>

							<div class="form-group row">
								<label class="control-label col-lg-3">Secondary Phone:</label>
								<div class="controls col-lg-6">
									<bw-phone
										v-model="contact.secondary_phone"
										:allow-extensions="true"
										:extension="contact.secondary_phone_ext"
										@extension="contact.secondary_phone_ext = $event"
									></bw-phone>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-light" data-dismiss="modal">
								Close
							</button>
							<button v-if="contact.id" type="button" class="btn btn-danger" @click="removeContact()" title="Remove merchant from venue" :disabled="isUpdatingContact">
								Remove
							</button>
							<button type="submit" class="btn btn-primary" :disabled="isUpdatingContact">
								<template v-if="newUser">
									Create
								</template>
								<template v-else>
									Save
								</template>
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>

		<create-message
			:recipients="recipients"
			@recipient-update="recipients = $event"
			:venue-id="venue && venue.id"
			:users="merchantUsers"
			:new-message="newMessage"
			@resetMsg="newMessage = true"
		></create-message>

		<div class="modal fade" id="sendMessage" tabindex="-1" role="dialog" aria-labelledby="sendMessage">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header bg-body-light">
						<h4 class="modal-title" id="sendMessageLabel">
							Send Message
						</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group row">
							<label class="d-block col-lg-3">Merchants:</label>
							<div class="col-lg-9">
								<div class="form-check" v-for="merchant in merchantUsers">
									<input class="form-check-input" type="checkbox" :value="merchant.id" v-model="message.recipientUserIds" id="user_ids" name="user_ids" />
									<label class="form-check-label" for="user_ids">{{ displayName(merchant) }}</label>
								</div>
							</div>
						</div>

						<div class="form-group row">
							<label for="external_id" class="col-lg-3 control-label">Template:</label>

							<div class="controls col-lg-9">
								<select class="form-control" v-model="message.template" v-if="messageTemplates.length">
									<option :value="null">- Select One -</option>
									<optgroup :label="campaign.name" v-for="campaign in messageTemplates">
										<option v-for="template in campaign.templates" :value="template">{{ template.subject }}</option>
									</optgroup>
								</select>
								<span v-else>No Templates</span>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-dismiss="modal">
							Close
						</button>
						<button type="button" class="btn btn-primary" @click="sendMessage()" :disabled="isSendingMessage">
							Send
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="sendMessageSystem" tabindex="-1" role="dialog" aria-labelledby="sendMessageSystem">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header bg-body-light">
						<h4 class="modal-title" id="sendMessageSystemLabel">
							Send Message To Admin
						</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group row">
							<label class="control-label col-lg-3">Message:</label>

							<div class="controls col-lg-9">
								<textarea class="form-control" rows="5" v-model="message.message"></textarea>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-dismiss="modal">
							Close
						</button>
						<button type="button" class="btn btn-primary" @click="sendMessage(true)" :disabled="isSendingMessage">
							Send
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
	.message-container {
		overflow-x: scroll;
	}
</style>

<script>
function fixVenueRoles(merchant) {
    merchant.venues.forEach(v => { if(v?.pivot?.role_id) {v.role_id = v.pivot.role_id}});
  }
	export default {
		props: {
			merchants: {
				type: Array,
				required: true,
			},
			venue: {
				type: Object,
			},
			campaign: {
				type: Object,
			},
			campaigns: {
				type: Array,
			},
			superAdmin: {
				type: Object,
			},
			systemUser: {
				type: Object,
			},
			venueAdminRole: {
				type: Object,
			},
			currentUser: {
				type: Object,
			},
			partner: {
				type: String | Number,
			},
			roles: {
				type: Array,
				required: false,
			},
			showLogs: {
				type: Boolean,
				default() {
					return true
				},
			},
			selectedMerchant: {
				type: Object,
				default() {
					return { messagePaginator: {} }
				},
			},
		},
		data: () => {
			return {
				contact: {},
				message: {
					params: {},
					template: null,
					send_email: 1,
					recipientUserIds: [],
				},
				isUpdatingContact: false,
				isSendingMessage: false,
				errors: [],
				messageTemplates: [],
				allLogs: {},
				newMessage: true,
				recipients: [],
				users: [],
				error_msg: '',
				success_msg: '',
				newUser: '',
				selectedUser: 'admin',
				selectedUserId: '',
			}
		},

		methods: {
			venueChanged(attr) {
				this.$emit('venue-changed', attr, this.venue[attr])
			},
			callMerchant(merchant, ev, phoneKey = 'phone') {
				let url = `/superAdmin/dialerWindow?user=${merchant.id}&phoneNumber=${merchant[phoneKey]}&autoDial=true&isContact=${merchant.type == 'contact'}`
				if (merchant[phoneKey + '_ext']) {
					url += '&phoneNumberExt=' + merchant[phoneKey + '_ext']
				}
				if (this.venue && this.venue.id) url += '&venueId=' + this.venue.id
				if (this.campaign && this.campaign.id) url += '&campaignId=' + this.campaign.id

				window.open(
					url,
					'targetWindow',
					`toolbar=no,
					location=no,
					status=no,
					menubar=no,
					scrollbars=yes,
					resizable=yes,
					width=300px,
					height=600px
					left=${window.screen.width - 300}
					top=${window.screen.height - 600}`
				)

				ev.stopPropagation()
			},
			getMpLink() {
				return `/merchant-portal/${this.venue?.id}/dashboard/main/view-dashboard`;
			},
			removeContact() {
				Bandwango.helpers('swal', {
					title: 'Are you sure?',
					text: 'You are removing this merchant from this venue.',
					type: 'delete',
					confirmButtonText: 'Yes, Remove them',
				}).then((result) => {
					if (result.value) {
						let i = this.contact.venues.findIndex((x) => (x.id ? x.id == this.venue.id : x == this.venue.id))
						if (i > -1) {
							this.contact.venues.splice(i, 1)
							this.addEditContact(true, true)
						}
					}
				})
			},

			openMessage(merchant, ev) {
				// this.message.user_filters.ids.push(merchant.id);
				this.message.recipientUserIds.push(merchant.id)
				$('#sendMessage').modal('show')
				ev.stopPropagation()
			},

			newContact() {
				this.contact = {role_id: this.venueAdminRole.id}
				this.newUser = true
				$('#add-edit-contact').modal('show')
			},

			editContact(merchant, ev) {
				this.contact = merchant
				const currentVenue = merchant.venues.find(v => v.id === this.venue.id)
				this.contact.current_venue_id = this.venue.id
				this.contact.role_id = currentVenue ? currentVenue.role_id : undefined
				this.newUser = false
				$('#add-edit-contact').modal('show')
				ev.stopPropagation()
			},

			sendMessage(isSystem) {
				const self = this
				this.isSendingMessage = true

				// Transitioned to private message

				// send out now
				// this.message.scheduled_at = moment().utc();

				if (this.message.template) {
					this.message.subject = this.message.template.subject
					// this.message.header_text = this.message.template.header_text;
					this.message.message = this.message.template.message
					this.message.attachments = this.message.template.attachments
					this.message.params.campaignId = this.message.template.campaignId
					this.message.partnerId = this.partner?.id || this.message.template.partnerId;
				}

				this.message.params.sendFromMerchants = true
				if (isSystem) {
					this.message.params.sendFromMerchants = false
					// this.message.user_filters.ids = [this.systemUser.id];
					this.message.recipientUserIds = [this.systemUser.id]
					this.message.subject = ((this.currentUser && this.currentUser.name) || 'A user') + ' has a question'
					this.message.message = ((this.currentUser && this.currentUser.name) || 'A user') + ' has a question<br><br>' + this.message.message
					// this.message.name = this.message.subject;
					this.message.message +=
						'<br>' +
						'<ul>' +
						'<li>Client: ' +
						((this.partner && this.partner.name) || 'Unknown') +
						'</li>' +
						'<li>Campaign: ' +
						((this.campaign && this.campaign.name) || 'Unknown') +
						'</li>' +
						'<li>Venue: ' +
						((this.venue && this.venue.name) || 'Unknown') +
						'</li>' +
						'<li>Merchants:</li><ul>'

					this.merchants.forEach((merch) => {
						this.message.message += '<li><span style="margin-left: 1em">' + merch.name + '</span></li>'
					})
					this.message.message += '</ul></li>'

					this.message.message += '<li>Bandwango User: ' + ((this.currentUser && this.currentUser.name) || 'Unknown') + ' ' + (this.currentUser && this.currentUser.email) + '</li>' + '</ul>'
				} else if (this.venue) {
					this.message.params.venueId = this.venue.id
				}

				this.message.params.sendInstant = true
				// axios.post(`/messages`, this.message).then(res => {
				axios
					.post(`/privateMessages`, this.message)
					.then((res) => {
						self.success_msg = 'Message sent'
						// this.message = {user_filters:{ids:[]}, template:null, send_email:1};
						self.message = {
							params: {},
							template: null,
							send_email: 1,
							recipientUserIds: [],
						}
						self.isSendingMessage = false
						$('#sendMessage').modal('hide')
						$('#sendMessageSystem').modal('hide')
					})
					.catch((error) => {
						self.error_msg = (error.response && error.response.data && error.response.data.message) || 'Something went wrong! Please try again!'
						self.isSendingMessage = false
					})
			},
			
			displayName(merchant) {
				if(!merchant.name || !merchant.name.trim()) {
					return merchant.email;
				}
				return merchant.name;
			},

			addEditContact(showMessage = true, isRemoving = false) {
				if (this.validateContact() || isRemoving) {
					this.isUpdatingContact = true

					if (!this.contact.partner_id && this.partner) this.contact.partner_id = this.partner.id

					// this.contact.addContactLogs = true;
					if (this.contact.id) {
						this.contact.venues = this.contact.venues.map((x) => (x.id ? x.venue_id || x.id : x));
						// make sure user is connected ot this venue
                        const oldId = this.contact.id;
                        const venueId = this.venue.id; //this.contact.venue_id; // !!! if type = user this field is undefined
                        const copyOfContactWithoutVenues = Object.assign({}, this.contact);
                        delete copyOfContactWithoutVenues.venues;
                        const call = !isRemoving ? axios.put(((this.superAdmin && this.superAdmin.userUrl) || this.getEntityUrl(venueId)) + '/' + this.contact.id + '?fullVenues=true', copyOfContactWithoutVenues) :
                            axios.delete(((this.superAdmin && this.superAdmin.userUrl) || this.getDeleteEntityUrl(venueId)) + '/' + this.contact.id);
                        call.then((res) => {
								//let i = this.merchants.findIndex((x) => x.id === res.data.id)
                                let i = this.merchants.findIndex((x) => x.id === oldId)
                                if (i > -1) {
                                    if (isRemoving) {
                                        this.merchants.splice(i, 1)
                                    } else {
                                        this.$set(this.merchants, i, {...this.merchants[i], ...res.data})
                                        fixVenueRoles(this.merchants[i])
                                    }
                                }

								if (showMessage) this.success_msg = 'User updated successfully.'

								this.isUpdatingContact = false
								$('#add-edit-contact').modal('hide')
							})
							.catch((error) => {
								this.error_msg = (error.response && error.response.data && error.response.data.message) || 'Something went wrong! Please try again!'
								this.isUpdatingContact = false
							})
					}
				}
			},
            getNewEntityUrl(venueId) {
                return this.contact.email?.trim()?.length > 0 ? '/users' : `/venues/${venueId}/contacts`;
            },
            getEntityUrl(venueId) {
                return this.contact.type === 'contact' ? `/venues/${venueId}/contacts` : '/users' ;
            },
            getDeleteEntityUrl(venueId) {
                return `/venues/${venueId}/${this.contact.type === 'contact' ? 'contacts' : 'users'}` ;
            },
            createContact() {
				this.contact.returnMatch = true
				//this.contact.role_id = this.venueAdminRole.id

				// Should we be doing this? Pass is required
				this.contact.require_new_password = 1
				this.contact.password = ''
				const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$'
				for (let i = 1; i <= 8; i++) this.contact.password += str.charAt(Math.floor(Math.random() * str.length + 1))

				this.contact.venues = [this.venue.id]

				if (this.validateContact()) {
				  const role_id = this.contact.role_id
                    const [firstVenueId] = this.contact.venues;
                    const entityUrl = this.getNewEntityUrl(firstVenueId);
                    axios
						.post(((this.superAdmin && this.superAdmin.userUrl) || entityUrl) + '?fullVenues=true&emptyDefaultName=true', this.contact)
						.then((res) => {
							this.contact = { ...res.data, ...{ messagePaginator: { data: [] } }, role_id }
							fixVenueRoles(this.contact)
							this.merchants.push(this.contact)
							this.success_msg = 'User updated successfully.'
							this.isUpdatingContact = false
							$('#add-edit-contact').modal('hide')
                            this.$emit('get-all-logs', true)
						})
						.catch((error) => {
                            console.error(error);
							this.error_msg = (error.response && error.response.data && error.response.data.message) || 'Something went wrong! Please try again!'
							this.isUpdatingContact = false
						})
				}
			},

			validateContact() {
				this.errors = {}
				const duplicate = this.merchants.filter((merchant) => (
                    this.contact.email &&
                    this.contact.email === merchant.email &&
                    this.contact.id !== merchant.id
                        ? true : false))
				if (duplicate.length > 0) {
					this.errors.email = 'This email already exists in the system.'
				} else {
					this.errors = {}
				}

				if (!this.contact.email && !this.contact.phone) {
                    this.errors.email = 'Please enter an email or phone number'
                    this.errors.phone = 'Please enter an email or phone number'
				}

				if (this.contact.email && !Bandwango.validEmail(this.contact.email)) {
					this.errors.email = 'Please enter a valid email address';
				}

                if (Object.keys(this.errors).length === 0) {
					return true
				}
				this.error_msg = 'Please fix any errors before saving.'
				return false
			},

			prepareMerchants() {
				this.merchants.forEach((merchant) => {
					this.getMerchantLogs(merchant)
				})

				if (this.campaign && this.campaign.callcenter_settings && this.campaign.callcenter_settings.messaging_templates && this.campaign.callcenter_settings.messaging_templates.length) {
					this.messageTemplates.push({
						name: this.campaign.name,
						templates: this.campaign.callcenter_settings.messaging_templates.map((x) => {
							x.campaignId = this.campaign.id;
							x.partnerId = this.campaign.partner_id;
							return x
						}),
					})
				}

				if (this.campaigns && this.campaigns.length) {
					this.campaigns.forEach((campaign) => {
						if (this.campaign && campaign.id === this.campaign.id) return true // continue
						if (campaign.callcenter_settings && campaign.callcenter_settings.messaging_templates && campaign.callcenter_settings.messaging_templates.length) {
							this.messageTemplates.push({
								name: campaign.name,
								templates: campaign.callcenter_settings.messaging_templates.map((x) => {
									x.campaignId = campaign.id;
									x.partnerId = campaign.partner_id;
									return x
								}),
							})
						}
					})
				}
			},
			addReadMoreAttribute: function (logs) {
				if (logs && logs.data) {
					logs.data.forEach((message, idx) => {
						message.readMore = false;
						message.idx = idx;
					});
				}
			},
			getMerchantLogs(merchant, reset = false) {
				let page = (!reset && merchant.messagePaginator && merchant.messagePaginator.current_page) || 0
				axios.get(`/superAdmin/getUserContactLogs/${merchant.id}?user=true&page=${++page}&isContact=${merchant.type == 'contact'}`).then((res) => {
					if (!reset && merchant.messagePaginator) {
						const old = JSON.parse(JSON.stringify(merchant.messagePaginator.data))
						res.data.data = old.concat(res.data.data)
					}
					const logs = res.data
					this.addReadMoreAttribute(logs)
					merchant.messagePaginator = logs
					this.$forceUpdate()
				})
			},

			getVenueLogs(reset = false) {
				if (!this.venue.id) return

				let page = (!reset && this.allLogs.messagePaginator && this.allLogs.messagePaginator.current_page) || 0

				axios.get(`/superAdmin/getUserLogsRegardingVenue/${this.venue.id}?page=${++page}`).then((res) => {
					if (!reset && this.allLogs.messagePaginator) {
						const old = JSON.parse(JSON.stringify(this.allLogs.messagePaginator.data))
						res.data.data = old.concat(res.data.data)
					}
					this.allLogs.messagePaginator = res.data
					this.$forceUpdate()
				})
			},

			copyToClip(link, ev) {
				ev.stopPropagation()
				Bandwango.copyToClipBoard(link)
			},

			expand(message) {
				message.readMore = true
				this.$forceUpdate()
			},
			async onSubmit(){
				if(this.newUser)
					this.createContact()
				else
					this.addEditContact()
			}
		},
		mounted() {
			this.prepareMerchants()
			this.getVenueLogs(false)

			Echo.channel('dialer-event').listen('CallDisconnect', (ev) => {
				if (ev.payload && ev.payload.customer) {
					let f = this.merchants.find((x) => x.id == ev.payload.customer.id)
                    if (f) {
						this.getMerchantLogs(f, true)
                        this.$emit('get-merchant-logs', f)
						this.venue.last_called = Bandwango.dateToUtc(moment())
						this.venueChanged('last_called')

						// hit the template function
						Bandwango.getCallTally()
					}
				}
			})
		},
		computed: {
            merchantUsers: function() {
                return this.merchants.filter(it => it.type == 'user')
            },
			orderedMerchants: function() {
				const merchants = this.merchants.sort((a, b) => {
					return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
				})

				let i = -1
				Object.keys(merchants).forEach((k) => {
					if (merchants[k].id === this.venue.contact_user_id) i = k
				})

				if (i > -1) {
					const f = this.merchants[i]
					merchants.splice(i, 1)
					merchants.splice(0, 0, f)
				}

				return merchants
			},
		},
		watch: {
			success_msg: function(msg) {
				if (msg) {
					One.helpers('notify', {
						align: 'center',
						type: 'success',
						icon: 'fa fa-check mr-1',
						message: msg,
					})
					this.success_msg = ''
				}
			},
			error_msg: function(msg) {
				if (msg) {
					One.helpers('notify', {
						align: 'center',
						type: 'danger',
						icon: 'fa fa-exclamation mr-1',
						message: msg,
					})
					this.error_msg = ''
				}
			},
		},
	}
</script>

<style lang="scss">
    .form-check--call-buttons {
        min-width: 106px;
    }
</style>
